__turbopack_context__.v({
  "body": "content-warning-module-scss-module__vDEL_a__body",
  "title": "content-warning-module-scss-module__vDEL_a__title",
});
